import * as React from 'react';
import { observer } from 'mobx-react';
import OfferedBy from './OfferedBy';
import Competencies from './Competencies';
import { ExperienceResource } from '../../../../../../../../../../../../Types';

export interface Props {
  resource: ExperienceResource;
}

const BodyRight: React.FC<Props> = ({ resource }) => (
  <div className="basis-2/4">
    <OfferedBy resource={resource} />
    <Competencies resource={resource} />
  </div>
);

export default observer(BodyRight);
